import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'src/redux'
/**
 * Select form data
 */
export const selectApplicationData = createSelector(
  (state: RootState) => state,
  (state) => state.application.application
)
export const selectApplicationState = createSelector(
  (state: RootState) => state,
  (state) => state.application
)
